export interface DataSyncMetricsBucket {
  bucket: string;
  tracker_id: string;
  datasync_id: string;
  stage: string;
  // Counter fields are uint64 in the proto; proto3 JSON encodes 64-bit ints
  // as strings to avoid precision loss past Number.MAX_SAFE_INTEGER.
  total_success_count?: number | string;
  total_error_count?: number | string;
  total_duration_ms?: number | string;
  event_count?: number | string;
}

export interface GetDataSyncMetricsResponse {
  metrics_buckets: DataSyncMetricsBucket[];
}

export enum DataSyncHealthStatus {
  HEALTHY = 'HEALTHY',
  WARNING = 'WARNING',
  FAILING = 'FAILING',
}

export interface DataSyncMetricsSummary {
  datasyncId: string;
  totalItems: number;
  totalErrors: number;
  successRate: number;
  errorRate: number;
  sparklineData: number[];
  healthStatus: DataSyncHealthStatus;
}
